"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepareAgencyEmailPayload = void 0;
var PrepareAgencyEmailPayload;
(function (PrepareAgencyEmailPayload) {
    let emailType;
    (function (emailType) {
        emailType["DIGEST"] = "digest";
        emailType["SPECIAL"] = "special";
        emailType["NOTIFY_ME"] = "notifyMe";
        emailType["REMINDER"] = "reminder";
        emailType["OUTREACH"] = "outreach";
        emailType["OTHER"] = "other";
        emailType["AGENCY_CREATOR_JOINS"] = "agencyCreatorJoins";
        emailType["AGENCY_CREATOR_LEAVES_BY_AGENT"] = "agencyCreatorLeavesByAgent";
        emailType["AGENCY_CREATOR_LEAVES_BY_CREATOR"] = "agencyCreatorLeavesByCreator";
        emailType["AGENCY_START_DEPLOYMENT"] = "agencyStartDeployment";
        emailType["AGENCY_DIGEST"] = "agencyDigest";
        emailType["ABUSE"] = "abuse";
    })(emailType = PrepareAgencyEmailPayload.emailType || (PrepareAgencyEmailPayload.emailType = {}));
    let digestFrequency;
    (function (digestFrequency) {
        digestFrequency["DAILY"] = "daily";
        digestFrequency["WEEKLY"] = "weekly";
    })(digestFrequency = PrepareAgencyEmailPayload.digestFrequency || (PrepareAgencyEmailPayload.digestFrequency = {}));
})(PrepareAgencyEmailPayload = exports.PrepareAgencyEmailPayload || (exports.PrepareAgencyEmailPayload = {}));
